/**
 * AnimatedDots — the three bouncing "AI is working" dots. Extracted from
 * the chatbot's TypingIndicator so the agent runner's working strip and
 * thinking bubble share one animation instead of re-declaring the
 * keyframes per feature (Rule 15 / DRY).
 *
 * @module AnimatedDots
 */

'use client';

import { Box, Flex } from '@axon/ui';

interface DotProps {
  delay: number;
  color: string;
}

function Dot({ delay, color }: DotProps) {
  return (
    <Box
      width="2"
      height="2"
      borderRadius="full"
      background={color}
      css={{
        '@keyframes bounce': {
          '0%, 60%, 100%': { transform: 'translateY(0)' },
          '30%': { transform: 'translateY(-4px)' },
        },
        animation: 'bounce 1.4s ease-in-out infinite',
        animationDelay: `${delay}s`,
      }}
    />
  );
}

interface AnimatedDotsProps {
  /** Chakra color token for the dots. */
  color?: string;
}

export function AnimatedDots({ color = 'gray.400' }: AnimatedDotsProps) {
  return (
    <Flex gap="1" align="center">
      <Dot delay={0} color={color} />
      <Dot delay={0.2} color={color} />
      <Dot delay={0.4} color={color} />
    </Flex>
  );
}

export default AnimatedDots;
